<template>
  <v-card v-if="selectedOrder" flat class="container--fluid">
    <v-card flat class="container--fluid bg-gray no-margins zindex-1">
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-row align="center" justify="space-between">
            <v-col cols="12" lg="7" sm="6" class="subtitle-1">
              <h4 class="mb-1">Beställning</h4>
              {{ selectedOrder.company.name }}, {{ selectedOrder.company.postalCity }}
            </v-col>
            <v-col cols="12" lg="5" sm="6" class="text-right d-flex">
              <v-select
                  label="STATUS"
                  outlined
                  :items="basicExtensionOrderStates"
                  item-text="name"
                  item-value="id"
                  :rules="[rules.required]"
                  v-model="selectedOrder.stateId"
                  hide-details
                  :disabled="!editState"
              ></v-select>
              <v-icon @click="editState=!editState" class="mt-4 ml-3" v-if="!editState" :disabled="!canUpdate">$sl-edit</v-icon>
              <v-icon class="mt-4 ml-3" @click="updateState()" v-else :disabled="!canUpdate">$sl-check</v-icon>
            </v-col>
          </v-row>
        </v-form>
        <template v-if="selectedOrder.orderedAt">
          <div class="body-2 mt-4">Beställning gjord {{ selectedOrder.orderedAt | date }}</div>
        </template>
      </v-card-text>
    </v-card>
    <v-card flat class="container--fluid">
      <ExtensionOrderDetails :selected-order="selectedOrder" @updated="updated"></ExtensionOrderDetails>
    </v-card>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {RulesMixin, CanIDo} from '@/components/mixins'
import find from 'lodash/find'
import ExtensionOrderDetails from "@/components/order/extensionOrder/ExtensionOrderDetails";
import {mapGetters} from "vuex";

// @group Order
// OrderDetail component
export default {
  name: 'ExtensionOrder',

  mixins: [RulesMixin, CanIDo],

  components: {
    ExtensionOrderDetails,
  },

  data: () => ({
    tab: 0,
    editState: false,
    selectedOrder: null,
  }),

  created() {
    this.fetchOrder()
  },

  watch: {
    '$route.params.id': {
      handler: (newVal, OldVal) => {
        this.fetchOrder()
      }
    },
  },

  computed: {
    ...mapGetters('basic', ['basicExtensionOrderStates', 'basicDistanceOrderStates']),

    paidStateId() {
      const ps = find(this.extensionOrderStates, ['state', 'paid'])
      return ps ? ps.id : -1
    }
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('order', 'update');
    },
  },

  methods: {
    /**
     * @vuese
     * Used to update distance order
     * @arg The argument is an integer representing  distance order id and param is state id
     */
    updateState() {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', 'Du måste välja en status.')
        return
      }
      this.editState = !this.editState

      if (this.$route.params.id > 0) {
        // @vuese
        //  Existing item
        API.updateExtensionOrder(this.$route.params.id, {
          data: {stateId: String(this.selectedOrder.stateId)}
        })
            .then(response => {
              this.$events.fire('showInfo', 'Sparad.')
              /**
               * @vuese
               * Used to update selected order in local store with new state id
               */
              this.selectedOrder = {
                ...response,
                stateId: this.selectedOrder.stateId,
                state: find(this.extensionOrderStates, ['id', this.selectedOrder.stateId])
              }
            })
            .catch(error => {
              console.log('There was an error:', error)
              this.$events.fire('showError', 'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.')
            })
      }
    },

    updated() {
      this.fetchOrder()
    },
    /**
     * @vuese
     * Used to fetch order
     * @arg The argument is an integer representing  distance order id
     */
    fetchOrder() {
      API.getExtensionOrder(this.$route.params.id)
          .then(response => {
            // @vuese
            // Set selected order  to local store distance order
            if (response && response.data && response.data.company && response.data.company.postalZip) {
              response.data.company.postalZip = this.$options.filters.postalZipFormat(response.data.company.postalZip)
            }

            this.selectedOrder = response.data;
          })
          .catch(error => {
            console.log('There was an error:', error)
          })
    }
  }
}
</script>

<style lang="scss">
</style>
